"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaService = function MediaService(HttpService) {
  "ngInject";

  var getDataSource = function getDataSource(successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("media/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "creationDate": { editable: false },
            "externalHashedId": {},
            "name": {},
            "mediaStatus": {},
            "mediaReviewStatus": {},
            "thumbnailUrl": {},
            "width": {},
            "height": {},
            "duration": {},
            "mediaType": {},
            "userId": {},
            "id": {}
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  return { getDataSource: getDataSource };
};

function _getResourceLocation(options) {
  return _env2.default.getApiUrl("media/" + options.id);
}

function _onBeforeSend(req) {
  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read") {
    var filters = [];

    if (data.filter) filters = data.filter.filters;

    var query = (0, _assign2.default)({}, { filters: filters }, data);
    delete query.filter;

    console.log("Query::", query);

    return (0, _stringify2.default)(query);
  }

  if (type == "update") {
    return (0, _stringify2.default)(data);
  }
}

exports.default = MediaService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/media.service.js
 **/